// extracted by mini-css-extract-plugin
module.exports = {"footer500":"Footer_footer-500__y6bdP","footer500OnlyLaptop":"Footer_footer-500--only-laptop__n5Uvf"};